import { TransactionItem } from '../../../graphql'

function render( items: TransactionItem[] ) {
	const totalWac = items.reduce( ( sum, item ) => {
		const amount = parseFloat( item.wacSnapshot?.weightedAverageCost?.amount ?? '0' )
		return sum + amount
	}, 0 )

	return `$${totalWac.toFixed( 2 )}`
}

export default {
	field: 'transactionItems',
	name: 'WAC',
	description: 'Weighted Average Cost',
	align: 'right',
	render,
}
